/** @jsxImportSource @emotion/react */

import More from './Menus/More'
import Organizations from './Menus/Organizations'
import SearchBar from './Menus/SearchBar'
import middleBar from './IDSHeaderStyle'
import './iqviaheader.css'
import IDSThemeProvider from 'apollo-react/utils/IDSThemeProvider'
import IDSSwitcher from './NetworkSwitcher/IDSSwitcher'

export const IDSSubHeaderEmbed = ({
  headerBar,
  tenantsIncluded,
  tenantName,
  image,
}) => {
  return (
    <IDSThemeProvider themeName="IDS">
      <div css={middleBar.middleBar}>
        <IDSSwitcher
          tenant={tenantName}
          image={image}
          tenantsIncluded={tenantsIncluded}
        />

        <div css={middleBar.fillElementStyle}></div>
        {headerBar?.meta?.institutions?.length > 0 && (
          <div css={middleBar.rightElementStyle}>
            <Organizations headerBar={headerBar} />
          </div>
        )}
        <div css={middleBar.rightElementStyle}>
          <More headerBar={headerBar} />
        </div>
        <div css={middleBar.searchElement}>
          <SearchBar />
        </div>
      </div>
    </IDSThemeProvider>
  )
}
export default IDSSubHeaderEmbed
